import { useState, type RefObject } from "react";
import { StatusModalMany } from "./StatusModal";
import type { AnchorPosition } from "../../ui/shared-styles";

export function useStatusModalActions(
  getAnchorPosition: () => AnchorPosition,
  onPopupOpen?: () => void,
  onPopupClose?: () => void,
  closeMenu?: () => void,
  menuRef?: RefObject<HTMLDivElement>,
) {
  const [open, setOpen] = useState(false);
  const [anchorPosition, setAnchorPosition] = useState<AnchorPosition | null>(null);

  const openStatusModal = () => {
    setAnchorPosition(getAnchorPosition());
    setOpen(true);
    onPopupOpen?.();
  };

  const closeStatusModal = (shouldCloseMenu = true) => {
    setOpen(false);
    setAnchorPosition(null);
    onPopupClose?.();
    if (shouldCloseMenu) {
      closeMenu?.();
    }
  };

  const StatusModal = open && anchorPosition && (
    <StatusModalMany
      setClose={() => closeStatusModal(true)}
      setCloseKeepMenu={() => closeStatusModal(false)}
      open={open}
      anchorPosition={anchorPosition}
      menuRef={menuRef}
    />
  );

  return {
    openStatusModal,
    closeStatusModal,
    StatusModal,
  };
}
